import { ExperienceProviderConfig } from "./types";
import React, { createContext, useContext, FC } from "react";

export const ExperienceProvidersContext = createContext<ExperienceProviderConfig[]>([]);

interface ExperienceProvidersProviderProps {
  children: React.ReactNode;
  experienceProviders: ExperienceProviderConfig[];
}

export const ExperienceProvidersProvider: FC<ExperienceProvidersProviderProps> = ({
  children,
  experienceProviders,
}) => {
  return (
    <ExperienceProvidersContext.Provider value={experienceProviders}>{children}</ExperienceProvidersContext.Provider>
  );
};

export const useExperienceProviders = () => useContext(ExperienceProvidersContext);
